// REMIND: true if all items in data are valid, false otherwise
export const hasAllRequiredPermissions = (
  requiredPerms: Array<string>,
  userPermissions: Array<string>,
): boolean => {
  return requiredPerms.every((perm) => userPermissions.includes(perm))
}

export const validatePerm = (scope: Array<string>, permission: Array<string>): boolean => {
  return permission.some((perm) => scope.includes(perm))
}
